"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LobbyConnection = void 0;
const state_1 = require("~/store/lobby/state");
class LobbyConnection {
    constructor(socket, dispatch) {
        this.socket = socket;
        this.dispatch = dispatch;
        this.cleanupFns = [];
        this.setupListeners();
    }
    handleConnected(payload) {
        this.dispatch(state_1.LobbyCommands.connectToLobby(payload));
    }
    sendStartNow() {
        this.socket.emit("startNow", { empty: true });
    }
    sendUpdateSetting(key, value) {
        this.socket.emit("updateSetting", { key, value });
    }
    destroy() {
        for (const cleanup of this.cleanupFns) {
            cleanup();
        }
        this.cleanupFns = [];
    }
    setupListeners() {
        const onLobbyUpdate = (payload) => {
            this.dispatch(state_1.LobbyCommands.updatePlayers(payload));
        };
        const onSettingsUpdate = (payload) => {
            this.dispatch(state_1.LobbyCommands.updateSettings(payload));
        };
        this.socket.on("lobbyUpdate", onLobbyUpdate);
        this.socket.on("settingsUpdate", onSettingsUpdate);
        this.cleanupFns.push(() => this.socket.off("lobbyUpdate", onLobbyUpdate), () => this.socket.off("settingsUpdate", onSettingsUpdate));
    }
}
exports.LobbyConnection = LobbyConnection;
